export default __webpack_public_path__ + "static/media/rocket.511ca251.svg";